unit View.Nbs.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UHelperServer, UPersonalizacao_Tabela, UUtils,
  UPersonalizacao_Tabela.Interfaces, UWeb.Enum, System.StrUtils;

type
  TFViewNbsList = class(TForm)
    btNew: TButton;
    NbsDataset: TXDataWebDataSet;
    NbsDatasetid: TIntegerField;
    NbsDatasetnbs: TStringField;
    NbsDatasetdescricao: TStringField;
    NbsDatasetexcluido: TBooleanField;
    NbsDatasetinclusao: TDateTimeField;
    NbsDatasetalteracao: TDateTimeField;
    NbsDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure NbsDatasetdescricaoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebFormShow(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewNbsList: TFViewNbsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNbsList }

procedure TFViewNbsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewNbsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNbsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewNbsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewNbsList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewNbsList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewNbsList.NbsDatasetdescricaoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString);
end;

procedure TFViewNbsList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewNbsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewNbsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      NbsDataset.Connection.Model.DefaultSchema.FindEntityType(NbsDataset.EntitySetName),
      NbsDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_nbs');
  end;
end;

procedure TFViewNbsList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['descricao']) of
      0: AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewNbsList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
    end;
  end;
end;

procedure TFViewNbsList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('nbs', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, NbsDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNbsList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao(NbsDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    btNew.Enabled := False;
end;

procedure TFViewNbsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.nbs.list.pagination.info');
  btNew := TButton.Create('view.nbs.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.nbs.list.table');
  cbPageSize := TComboBox.Create('view.nbs.list.cbPageSize');
  edSearch := TEdit.Create('view.nbs.list.search');
  lcPaginator := TListControl.Create('view.nbs.list.pagination');
  NbsDataset := TXDataWebDataSet.Create(Self);
  NbsDatasetid := TIntegerField.Create(Self);
  NbsDatasetnbs := TStringField.Create(Self);
  NbsDatasetdescricao := TStringField.Create(Self);
  NbsDatasetexcluido := TBooleanField.Create(Self);
  NbsDatasetinclusao := TDateTimeField.Create(Self);
  NbsDatasetalteracao := TDateTimeField.Create(Self);
  NbsDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  NbsDataset.BeforeLoadDFMValues;
  NbsDatasetid.BeforeLoadDFMValues;
  NbsDatasetnbs.BeforeLoadDFMValues;
  NbsDatasetdescricao.BeforeLoadDFMValues;
  NbsDatasetexcluido.BeforeLoadDFMValues;
  NbsDatasetinclusao.BeforeLoadDFMValues;
  NbsDatasetalteracao.BeforeLoadDFMValues;
  NbsDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewNbsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nbs';
      Title := 'nbs';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    NbsDataset.SetParentComponent(Self);
    NbsDataset.Name := 'NbsDataset';
    NbsDataset.EntitySetName := 'Nbs';
    NbsDataset.Connection := DMConnection.ApiConnection;
    NbsDataset.Left := 72;
    NbsDataset.Top := 144;
    NbsDatasetid.SetParentComponent(NbsDataset);
    NbsDatasetid.Name := 'NbsDatasetid';
    NbsDatasetid.FieldName := 'id';
    NbsDatasetid.Required := True;
    NbsDatasetnbs.SetParentComponent(NbsDataset);
    NbsDatasetnbs.Name := 'NbsDatasetnbs';
    NbsDatasetnbs.FieldName := 'nbs';
    NbsDatasetnbs.Required := True;
    NbsDatasetnbs.Size := 255;
    NbsDatasetdescricao.SetParentComponent(NbsDataset);
    NbsDatasetdescricao.Name := 'NbsDatasetdescricao';
    NbsDatasetdescricao.FieldName := 'descricao';
    NbsDatasetdescricao.Required := True;
    SetEvent(NbsDatasetdescricao, Self, 'OnGetText', 'NbsDatasetdescricaoGetText');
    NbsDatasetdescricao.Size := 255;
    NbsDatasetexcluido.SetParentComponent(NbsDataset);
    NbsDatasetexcluido.Name := 'NbsDatasetexcluido';
    NbsDatasetexcluido.FieldName := 'excluido';
    NbsDatasetinclusao.SetParentComponent(NbsDataset);
    NbsDatasetinclusao.Name := 'NbsDatasetinclusao';
    NbsDatasetinclusao.FieldName := 'inclusao';
    NbsDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NbsDatasetalteracao.SetParentComponent(NbsDataset);
    NbsDatasetalteracao.Name := 'NbsDatasetalteracao';
    NbsDatasetalteracao.FieldName := 'alteracao';
    NbsDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    NbsDatasetexclusao.SetParentComponent(NbsDataset);
    NbsDatasetexclusao.Name := 'NbsDatasetexclusao';
    NbsDatasetexclusao.FieldName := 'exclusao';
    NbsDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := NbsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    NbsDataset.AfterLoadDFMValues;
    NbsDatasetid.AfterLoadDFMValues;
    NbsDatasetnbs.AfterLoadDFMValues;
    NbsDatasetdescricao.AfterLoadDFMValues;
    NbsDatasetexcluido.AfterLoadDFMValues;
    NbsDatasetinclusao.AfterLoadDFMValues;
    NbsDatasetalteracao.AfterLoadDFMValues;
    NbsDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
